exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#outPopUp {\n    position: absolute;\n    width: 300px;\n    height: 200px;\n    z-index: 15;\n    top: 50%;\n    left: 50%;\n    margin: -100px 0 0 -150px;\n    background: red;\n  }\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/page/page.component.css
// module id = ../../../../../src/app/components/pages/page/page.component.css
// module chunks = main